module.exports = __webpack_public_path__ + "static/media/transparency4.6e3a3bc2.jpg";